<aside class="header-section">
    <div class="header-section__container">
        <div class="classic-itinerary">
            <p class="classic-itinerary__head">Here is your</p>
            <h3 class="classic-itinerary__main">{{ planningTypeText }}</h3>
            <p class="classic-itinerary__sub">Go ahead and make it perfect</p>
        </div>
        <div class="or-divider">
            <span></span>
            <p>or</p>
            <span></span>
        </div>
        <div class="classic-itinerary classic-itinerary--fixed">
            <p class="classic-itinerary__head">Chat with our</p>
            <h3 class="classic-itinerary__main classic-itinerary__main--black">Optimized AI</h3>
            <p class="classic-itinerary__sub">Describe your perfect trip</p>
            <button class="btn-default classic-itinerary__button" (click)="openAiDialog()">
                Start Chat
            </button>
        </div>
        <div class="or-divider">
            <span></span>
            <p>or</p>
            <span></span>
        </div>
        <div class="classic-itinerary classic-itinerary--fixed">
            <p class="classic-itinerary__head">Browse our</p>
            <h3 class="classic-itinerary__main classic-itinerary__main--black">Popular Itineraries</h3>
            <p class="classic-itinerary__sub">Traveled by thousands</p>
            <button class="btn-default classic-itinerary__button"
                    (click)="scrollToAnchor(42); setBrowserAndEditAnalytic()">
                Browse and edit
            </button>
        </div>
        <div class="popular-box">
            <app-popular-itineraries
                    [isHeader]="false"
                    [customTrips]="topTips"
                    [isFetching]="isTripsFetching"
                    [infoType]="eInfoType.TRIP"
                    [swiperWrapperClass]="['swiper-wrapper--trip-planer']"
                    [swiperSlideClass]="['swiper-slide--trip-planer']"
            ></app-popular-itineraries>
        </div>
    </div>
</aside>
<section class="planner-section">
    <div class="planner-interaction">
        <div class="planner-interaction__top"
             [class.planner-interaction__top--sticky-box]="plannerView === ETripPlannerView.CITY_OVERVIEW">
            @if (isCreateTripFetching) {
                <ngx-skeleton-loader [theme]="{height: '44px', width: '600px'}"></ngx-skeleton-loader>
            } @else {
                <div class="f-row f-v-center">
                    <p class="extracted-from-title">My plan:&nbsp;</p>
                    <h1> {{ correctTripName }}</h1>
                    <span class="rename-option" (click)="openRenameTripDialog()">
                      Rename
                    </span>
                </div>
            }
            <div class="planner-interaction__top__actions">
                <button class="action-box"
                        (click)="shareHandle()"
                        [disabled]="!createdTrip && !createdTrip?.destinations">
                    <img src="assets/svg/ic-share.svg" width="32" height="32" alt="share">
                </button>
                <button class="action-box"
                        (click)="printHandle(printElementRef)"
                        [disabled]="!createdTrip && !createdTrip?.destinations">
                    <img src="assets/svg/ic-print.svg" alt="print">
                </button>
                <button class="wishlist-button" (click)="goToWishlistHandler()">
                    <span class="wishlist-button__badge">{{ favoritesAmount }}</span>
                    <p>My wishlist</p>
                </button>
            </div>
        </div>
        @if (trip.plannerInfo && trip.plannerInfo.type === 'popular') {
            <p class="planner-interaction__description">
                {{ trip.plannerInfo.description }}
            </p>
        }
        <div #topControlEl
             class="planner-interaction__content"
             [style.padding-bottom.px]="calculatedPaddingBottom">
            @if (isUpdatingByUserInteraction) {
                <div class="planner-interaction__content__fast-update">
                    <img ngSrc="assets/svg/circles.svg" width="100" height="100" alt="loading">
                    <p>Updating itinerary</p>
                </div>
            }
            <div #destinationBox
                 class="destination-box"
                 [class.destination-box--simple]="plannerView === ETripPlannerView.CITY_OVERVIEW"
            >
                @if (!isCreateTripFetching) {
                    <div class="destination-box__top">
                        <div class="toggle-box">
                            <span>Manual</span>
                            <mat-slide-toggle
                                    class="optimize-toggle"
                                    [hideIcon]="true"
                                    [checked]="trip.isOptimizedMode"
                                    (change)="togglePlanningModeHandler($event)"
                            ></mat-slide-toggle>
                            <span>Optimizer</span>
                        </div>
                        <button class="action-button action-button--destination" (click)="openAddDestinationDialog()">
                            <img ngSrc="assets/svg/ic-add-3.svg" width="34" height="34" alt="Add destinations">
                            <span class="action-text">Add destination</span>
                        </button>
                        @if ((userStatus | async) === false) {
                            <button class="action-button action-button--save" (click)="saveTripHandler()">
                                <img ngSrc="assets/svg/ic-save.svg" width="30" height="30" alt="Save">
                                <span class="action-text">Save</span>
                            </button>
                        }
                        <button class="action-button action-button--undo" (click)="handleUndo()"
                                [disabled]="tripWizardStateService.isUndoDisabled">
                            <img ngSrc="assets/svg/ic-undo.svg" width="30" height="30" alt="Undo">
                            <span class="action-text">Undo</span>
                        </button>
                        <button class="action-button action-button--redo" (click)="handleRedo()"
                                [disabled]="tripWizardStateService.isRedoDisabled">
                            <img ngSrc="assets/svg/ic-redo.svg" width="30" height="30" alt="Redo">
                            <span class="action-text">Redo</span>
                        </button>
                    </div>
                    @if (createdTrip) {
                        <app-trip-destinations-list
                                [legs]="legs"
                                [plannerView]="plannerView"
                                [isSpecifyDates]="trip.isSpecifyDates"
                                [isOptimizedMode]="trip.isOptimizedMode"
                                [destinations]="createdTrip.destinations"
                                [packages]="packageResponse?.results || []"
                                [cityInfoIndex]="cityInfoIndex"
                                (toggleExpand)="toggleDestinationsExpand(destinationBox)"
                                (toggleSightsOnTheWay)="toggleDestinationsExpand(destinationBox, true)"
                                (onSelectTrip)="handleChangeTrip($event)"
                                (changeDestinationDuration)="changeDestinationDurationHandler($event)"
                                (onLockOrUnlockDestination)="toggleLockDestinationHandler($event)"
                                (changeDestination)="changeDestinationHandler($event)"
                                (removeDestination)="removeDestinationHandler($event)"
                                (toggleDestinationsChanges)="changeDestinationsHandler()"
                        ></app-trip-destinations-list>
                    }
                } @else {
                    <ngx-skeleton-loader
                            [theme]="{height: '600px', width: destinationBox.clientWidth + 'px', borderRadius: '30px'}"
                    ></ngx-skeleton-loader>
                }
            </div>
            <div class="overview-box"
                 [class.overview-box--full]="plannerView !== ETripPlannerView.PLANNER_OVERVIEW">
                @if (!isCreateTripFetching) {
                    <div class="overview-box__top"
                         [class.overview-box__top--sticky-box]="plannerView === ETripPlannerView.CITY_OVERVIEW">
                        @if (plannerView !== ETripPlannerView.PLANNER_OVERVIEW) {
                            <div class="back-to-planner" (click)="changePlannerView(ETripPlannerView.PLANNER_OVERVIEW)">
                                <span class="back-to-planner__arrow"><</span>
                                <div class="back-to-planner__view">
                                    <img ngSrc="assets/svg/ic_planner.svg" width="38" height="34" alt="planner">
                                    <p>Back to planner</p>
                                </div>
                            </div>
                        }
                        @if (plannerView === ETripPlannerView.CITY_OVERVIEW) {
                            @if (createdTrip && createdTrip.destinations; as destinations) {
                                <div class="select-city"
                                     [matMenuTriggerFor]="menu"
                                     #menuTrigger="matMenuTrigger"
                                >
                                    <div class="select-city-btn"
                                         (click)="$event.preventDefault()">
                                        <mat-icon class="up"
                                                  [svgIcon]="eSvgIcons.ARROW_CITY_DOWN"
                                                  [class.active]="!disablePrevCity && cityInfoIndex > 0"
                                                  (click)="menuTrigger.closeMenu()"
                                        ></mat-icon>
                                        @if (cityInfoIndex < 0) {
                                            <span class="circle" (click)="menuTrigger.closeMenu()"></span>
                                        } @else {
                                            <div class="circle-active" [style.--pin-color]="PIN_COLORS[cityInfoIndex]">
                                                <span class="circle-active__index">{{ cityInfoIndex + 1 }}</span>
                                            </div>
                                        }
                                        <mat-icon class="down"
                                                  [svgIcon]="eSvgIcons.ARROW_CITY_DOWN"
                                                  [class.active]="!disableNextCity"
                                                  (click)="menuTrigger.closeMenu()"
                                        ></mat-icon>
                                    </div>
                                    @if (cityInfoIndex < 0) {
                                        <p class="select-city-label">Select a city</p>
                                    } @else {
                                        <p class="select-city-label">{{ createdTrip.destinations[cityInfoIndex].cityName }}</p>
                                    }
                                    <mat-menu #menu="matMenu" class="city-menu--dropdown">
                                        <div style="max-height: 340px; overflow-y: auto">
                                            @for (item of destinations; track idx; let idx = $index) {
                                                <button mat-menu-item
                                                        (click)="changePlannerView(ETripPlannerView.CITY_OVERVIEW); cityInfoIndex = idx"
                                                        class="city-dropdown--button">
                                                <span class="f-row  f-v-center">
                                                          <div class="item-pin" [style.--pin-color]="PIN_COLORS[idx]">
                                                            <span class="item-pin__index">{{ idx + 1 }}</span>
                                                        </div>
                                                    {{ item.cityName }}
                                                </span>
                                                </button>
                                            }
                                        </div>
                                        <p class="city-dropdown--info">
                                            Choose to explore city services and much more
                                        </p>
                                    </mat-menu>
                                </div>
                            }
                        }

                        <div class="overview-box__navbar">
                            @if (plannerView === ETripPlannerView.CITY_OVERVIEW) {
                                @if (createdTrip.destinations) {
                                    <div class="trip-info">
                                        <div class="trip-duration">
                                            @if (trip.isSpecifyDates) {
                                                <p class="trip-duration--days">
                                                    {{ createdTrip.destinations[cityInfoIndex].dates.from }} -
                                                    {{ createdTrip.destinations[cityInfoIndex].dates.to }}
                                                </p>
                                            }
                                            @if (createdTrip.destinations[cityInfoIndex]?.days) {
                                                <p class="trip-duration--nights">
                                                    {{ createdTrip.destinations[cityInfoIndex].days }}
                                                    nights
                                                </p>
                                            }
                                        </div>
                                    </div>
                                }

                                <div class="overview-box__navbar__book">
                                    <p>
                                        Book hotels, become a member, <span
                                            class="light-text"> enhance your trip with </span> free travel perks
                                    </p>
                                </div>
                            }
                            @if ([ETripPlannerView.PLANNER_OVERVIEW, ETripPlannerView.CAR_RENTAL_BOX, ETripPlannerView.FLIGHTS_BOX].includes(plannerView)) {
                                <div class="trip-info">
                                    <div class="trip-book">
                                        <div class="trip-book__col">
                                            <p>Book hotels</p>
                                            <p>Enjoy free perks</p>
                                        </div>
                                        <div class="trip-book__col">
                                            <mat-icon [svgIcon]="eSvgIcons.RECT"></mat-icon>
                                        </div>
                                    </div>
                                </div>
                            }
                            <div class="menu-bar">
                                @if (isCreateTripFetching) {
                                    @for (s of SERVICES; let idx = $index; track idx) {
                                        <div class="menu-item" [class.menu-item--equal]="idx < 6">
                                            <ngx-skeleton-loader
                                                    [theme]="{
                                                  height: '60px',
                                                  width: idx < 5 ? '78px' : '50px',
                                                  margin: '0'
                                                }"
                                            ></ngx-skeleton-loader>
                                        </div>
                                        @if (idx < 6) {
                                            <div class="menu-divider"></div>
                                        }
                                    }
                                } @else {
                                    @for (s of SERVICES; let idx = $index; track idx) {
                                        <div class="menu-item" [class.menu-item--equal]="idx < 6"
                                             (click)="selectService(idx); setTourismServiceMenuAnalytic(s.googleAnalytic)">
                                            <img class="menu-item__img" [src]="'assets/svg/' + s.icon" [alt]="s.type">
                                            <span class="menu-item__text">{{ s.type | titlecase }}</span>
                                        </div>
                                        @if (idx < 6) {
                                            <div class="menu-divider"></div>
                                        }
                                    }
                                    <span class="menu-active-state"
                                          [class.menu-active-state--hidden]="plannerView === ETripPlannerView.PLANNER_OVERVIEW"
                                    ></span>
                                }
                            </div>
                        </div>
                    </div>
                    <div class="overview-box__content"
                         [class.overview-box__content--simple]="plannerView === ETripPlannerView.CITY_OVERVIEW"
                         [class.overview-box__content--no-box]="plannerView === ETripPlannerView.PLANNER_OVERVIEW"
                    >
                        <div class="map-overview"
                             [class.map-overview--hidden]="plannerView !== ETripPlannerView.PLANNER_OVERVIEW">
                            @if (destinationsRoute && destinationsRoute.length) {
                                <div class="map-overview__container">
                                    <div class="map-overview__preferences-overlay">
                                        @if (trip.isOptimizedMode) {
                                            <button
                                                    class="preferences-btn"
                                                    [class.preferences-btn--toggled]="showPreferences"
                                                    (click)="showPreferences = !showPreferences"
                                            >
                                                <p>My trip preferences</p>
                                                <mat-icon [svgIcon]="eSvgIcons.ARROW_RIGHT_D"></mat-icon>
                                            </button>
                                        } @else {
                                            <p class="preferences-off">
                                                Turn Optimizer on <br/> to adjust your trip preferences
                                            </p>
                                        }
                                        <app-trip-preferences
                                                [showTripPreferences]="showPreferences"
                                                (sliderEvent)="changeTripPreferencesHandler()"
                                        ></app-trip-preferences>
                                    </div>
                                    <app-preview-map
                                            [savedTripView]="true"
                                            [destinationsRoute]="destinationsRoute"
                                            (tripLegs)="setParsedTripLegs($event)"
                                    ></app-preview-map>
                                </div>
                            }
                        </div>
                        @switch (plannerView) {
                            @case (ETripPlannerView.CITY_OVERVIEW) {
                                <div class="partners-container">
                                    @if (createdTrip && createdTrip.destinations; as destinations) {
                                        <app-trip-city-info
                                                [destinations]="destinations"
                                                [cityInfoIndex]="cityInfoIndex"
                                                [legs]="legs"
                                                [packages]="packageResponse?.results || []"
                                                [trip]="trip"
                                                (onCityIndexChange)="cityInfoIndex = $event"
                                        ></app-trip-city-info>
                                    }
                                </div>
                            }
                            @case (ETripPlannerView.FLIGHTS_BOX) {
                                <div class="partners-container">
                                    <p class="partners-container__title">
                                        Flights
                                    </p>
                                    @if (createdTrip && createdTrip.destinations; as destinations) {
                                        <app-book-flights-link
                                                [itineraryItem]="destinations[0]"
                                        ></app-book-flights-link>
                                    }
                                </div>
                            }
                            @case (ETripPlannerView.CAR_RENTAL_BOX) {
                                <div class="partners-container">
                                    <p class="partners-container__title">Car Rental</p>
                                    @if (carRentalQuery) {
                                        <app-car-rental-preview
                                                [currencyCode]="apiSettingsService.currency"
                                                [query]="carRentalQuery"
                                        ></app-car-rental-preview>
                                    }
                                </div>
                            }
                        }
                    </div>
                } @else {
                    <ngx-skeleton-loader
                            [theme]="{height: '600px', width: '100%', borderRadius: '30px'}"
                    ></ngx-skeleton-loader>
                }
            </div>
        </div>
    </div>
    @if (plannerView !== ETripPlannerView.CITY_OVERVIEW) {
        @if (topTips?.length || isTripsFetching) {
            <section class="section-box">
                <app-booking-banner
                        [countryName]="trip.startingCountry"
                        [cityName]="trip.startingLocationId"
                ></app-booking-banner>
                <div class="section-box__header" id="element-id-42">
                    <h2 class="align-filter">
                        Popular Trips <b>Get inspired</b>
                    </h2>
                </div>
                <div class="section-box__content">
                    <app-trip-card-list
                            [isFetching]="isTripsFetching"
                            [trips]="topTips"
                    ></app-trip-card-list>
                </div>
            </section>
        }
        @if (occasionGeniusResponse?.eventsSearchedAndSortedCloned?.length || isOccasionGeniusFetching) {
            <section class="section-box">
                <div class="section-box__header">
                    <h2 class="align-filter">
                        {{ 'OCCASION_GENIUS.EVENT_COLANDER_IN' | translate: {location: createdTrip?.destinations[0]?.cityName || ''} }}
                    </h2>
                    <app-search-input-field
                            [placeholder]="'OCCASION_GENIUS.SEARCH_PLACEHOLDER' | translate: {location: createdTrip?.destinations[0]?.cityName} "
                            [showSortDirection]="false"
                            [disabled]="isOccasionGeniusFetching"
                            (searchChanged)="occasionGeniusResponse.filterAndSortEvents($event)"
                    ></app-search-input-field>
                </div>
                <div class="section-box__content">
                    <app-occasion-genius
                            [cityId]="createdTrip?.destinations[0]?.id"
                            [cityName]="createdTrip?.destinations[0]?.cityName"
                            [countryName]="createdTrip?.destinations[0]?.countryName"
                            [isFetching]="isOccasionGeniusFetching"
                            [occasionGeniusResponse]="occasionGeniusResponse"
                            [eventsSearchedAndSorted]="occasionGeniusResponse.eventsSearchedAndSorted"
                    ></app-occasion-genius>
                </div>
            </section>
        }
    } @else if (createdTrip && createdTrip.destinations) {
        <div class="partners-container__actions">
            <button class="btn-default btn--prev"
                    (click)="prevCityInfo()"
                    [disabled]="disablePrevCity"
            >
                {{ 'TRIP_PLANNER.PREVIOUS_CITY' | translate: {location: cityInfoIndex === 0 ? '' : createdTrip.destinations[cityInfoIndex - 1].cityName} }}
            </button>
            <button class="btn-default btn--next"
                    (click)="nextCityInfo()"
                    [disabled]="disableNextCity">
                {{ 'TRIP_PLANNER.NEXT_CITY' | translate: {location: cityInfoIndex === createdTrip.destinations.length - 1 ? '' : createdTrip.destinations[cityInfoIndex + 1].cityName} }}
            </button>
        </div>
    }
</section>

<app-trip-plan-print
    #printElementRef
    [tripName]="trip?.name || createdTrip?.name"
    [itineraryItems]="createdTrip?.destinations"
></app-trip-plan-print>
